// import "./home.css";
import Arrow from "../../assets/images/icons/Icon-Freccia-menu.svg";
import { Link } from "react-router-dom";
import useRestList from "../_shared/hooks/useRestList";
import AppText from "../_shared/components/AppText";
import AppButton from "../_shared/components/AppButton";

import BackIcon from "../_shared/components/BackIcon";
import { useEffect, useState } from "react";
import "./video.css";
import { getResourceList } from "../../api";
import SideMenu from "../_shared/components/SideMenu";
import CloseIcon from "../_shared/components/CloseIcon";
import PlayVideo from "../../assets/images/icons/Play_video.png";

function Videos(props) {
  const { setSplash } = props;
  useEffect(() => setSplash(false), []);
  const [videos] = useRestList("/videos", null, { pageSize: 100 });
  const [openVideo, setOpenVideo] = useState();

  return (
    <div className="rootMenu">
      <SideMenu></SideMenu>
      {!openVideo ? (
        <div className="rootContent">
          <div className="row">
            <BackIcon></BackIcon>
            <div>
              <AppText bold>Video tecnici</AppText>
              <AppText light>Technical videos</AppText>
            </div>
          </div>

          <div className="row" style={{ marginTop: "1%", marginLeft: 30 }}>
            {videos?.map((video) => {
              return (
                <div
                  style={{
                    width: 300,
                    height: 300,
                    marginRight: 40,
                    marginBottom: 20,
                  }}
                  onClick={() => setOpenVideo(video)}
                >
                  <div
                    style={{
                      aspectRatio: 1.4,
                      minWidth: 300,
                      height: 200,
                      background: `url(${video?.image})`,
                      backgroundSize: "contain",
                      backgroundRepeat: "no-repeat",
                    }}
                  >
                    <img
                      style={{
                        position: "relative",
                        alignSelf: "center",
                        top: "35%",
                        left: "40%",
                        height: 50,
                        width: 50,
                      }}
                      alt=""
                      src={PlayVideo}
                    />
                  </div>

                  <AppText small bold>
                    {video?.name}
                  </AppText>
                  <AppText small>{video?.description}</AppText>
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        <div className="rootContent">
          <div className="centerPage">
            <div className="rightPage">
              <CloseIcon onClick={() => setOpenVideo(null)} />
            </div>
            <video
              autoPlay
              src={openVideo?.url}
              width="100%"
              height="100%"
              controls
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default Videos;
